export default "__VITE_ASSET__fa6693fc__"